import type { SupportedLocales } from './locale'

/**
 * Default format patterns by locale
 *
 * Using Map instead of Record for faster lookup
 */
export const defaultDateFormats: Map<SupportedLocales | string, string> =
	new Map([['en-US', 'MM/dd/yyyy']])
